import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { DataService } from "./services/data.services";
import { CommonService } from "./services/common.service";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { SharedModule } from "./shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthGuard } from "./utils/authguard/auth.guard";
import { ApiResponseInterceptorProvider } from "./utils/interceptors/api-response.interceptor";
import { SidebarService } from "@caseworthy/cw-ui-components";
import { AuthCookiesResolver } from "./utils/resolver/auth-cookies.resolver";
import { CanDeactivateGuard } from "./utils/component-deactivate/component-deactivate.guard";

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule
    ], 
    providers: [
        DataService,
        CommonService,
        AuthGuard,
        CanDeactivateGuard,
        ApiResponseInterceptorProvider,
        SidebarService,
        AuthCookiesResolver,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
